import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./agentforceChat.html";
/* eslint-disable @lwc/lwc/no-document-query */
import { CONFIG } from '~/modules/config';
import { handleException } from '~/modules/utilities/error_utilities';
import { logger } from '~/modules/utilities/logger';
const AGENTFORCE_CHAT_ID = 'agentforce-chat-loader';
const SCRIPT_LOAD_TIMEOUT = 5000;
class AgentforceChat extends LightningElement {
  constructor(...args) {
    super(...args);
    this.handleEmbeddedMessagingReady = () => {
      const {
        embeddedservice_bootstrap
      } = window;
      embeddedservice_bootstrap.settings.displayMode = 'inline';
      embeddedservice_bootstrap.settings.targetElement = document.getElementById('embeddedMessagingContainer');
      embeddedservice_bootstrap.settings.enableUserInputForConversationWithBot = false;
    };
    this.handleEmbeddedMessagingButtonCreated = () => {
      window.embeddedservice_bootstrap.utilAPI.launchChat();
      this.observeChatOverlay();
    };
    this.toggleChatPanel = () => {
      const chatPanel = document.getElementById('chatPanel');
      const chatButton = document.getElementById('agentforceChatButton');
      if (!chatPanel || !chatButton) {
        return;
      }
      const isOpen = chatPanel.classList.toggle('hidden-af');
      chatButton.classList.toggle('hidden-af', !isOpen);
      window.embeddedservice_bootstrap?.utilAPI?.launchChat();
      localStorage.setItem('isAgentforceChatOpen', String(!isOpen));
    };
  }
  async connectedCallback() {
    try {
      this.createChatUI();
      await this.loadAgentForceChatScript();
      this.initEmbeddedMessaging();
      this.attachEventListeners();
      setTimeout(() => {
        this.restoreChatState();
      }, 1000);
    } catch (exception) {
      handleException(exception, 'agentforceChat.initAgentforceChat');
    }
  }
  createChatUI() {
    const {
      button,
      panel
    } = this.createChatElements();
    document.body.appendChild(button);
    document.body.appendChild(panel);
  }
  createChatElements() {
    const button = this.createChatButton();
    const panel = this.createChatPanel();
    return {
      button,
      panel
    };
  }
  createChatButton() {
    const button = this.createElementWithClass('button', 'af-chat-btn', 'hidden-af');
    button.id = 'agentforceChatButton';
    button.addEventListener('click', this.toggleChatPanel);
    const iconDiv = this.createElementWithClass('div', 'af-chat-btn-icon');
    const iconImg = document.createElement('img');
    iconImg.src = '/assets/images/AgentforceIcon.svg';
    iconDiv.appendChild(iconImg);
    const textDiv = this.createElementWithClass('div', 'af-chat-btn-text');
    textDiv.textContent = 'Ask Agentforce';
    button.appendChild(iconDiv);
    button.appendChild(textDiv);
    return button;
  }
  createChatPanel() {
    const panel = this.createElementWithClass('div', 'af-chat-panel', 'hidden-af');
    panel.id = 'chatPanel';
    const container = this.createElementWithClass('div', 'af-messaging-container');
    container.id = 'embeddedMessagingContainer';
    panel.appendChild(container);
    return panel;
  }
  createElementWithClass(tag, ...classes) {
    const element = document.createElement(tag);
    element.classList.add(...classes);
    return element;
  }
  async loadAgentForceChatScript(retryCount = 3, retryDelay = 1000) {
    if (document.getElementById(AGENTFORCE_CHAT_ID)) {
      return Promise.resolve();
    }
    const scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = AGENTFORCE_CHAT_ID;
      script.src = CONFIG.EMBEDDED_SERVICE_SCRIPT_URL;
      script.async = false;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('AGENTFORCE_CHAT_LOAD_ERROR'));
      document.head.appendChild(script);
    });
    const timeoutPromise = new Promise((_, reject) => setTimeout(() => reject(new Error('AGENTFORCE_CHAT_LOAD_TIMEOUT')), SCRIPT_LOAD_TIMEOUT));
    try {
      return await Promise.race([scriptPromise, timeoutPromise]);
    } catch (error) {
      if (retryCount > 0) {
        logger.warn(`Failed to load AgentForce chat script. Retrying... (${retryCount} attempts left)`);
        // Remove the failed script element
        const failedScript = document.getElementById(AGENTFORCE_CHAT_ID);
        if (failedScript) {
          failedScript.remove();
        }
        await new Promise(resolve => setTimeout(resolve, retryDelay * Math.pow(2, 3 - retryCount)));
        return this.loadAgentForceChatScript(retryCount - 1, retryDelay);
      }
      logger.error('Failed to load AgentForce chat script after multiple attempts');
      throw error;
    }
  }
  initEmbeddedMessaging() {
    try {
      const {
        embeddedservice_bootstrap
      } = window;
      embeddedservice_bootstrap.settings.language = 'en_US';
      embeddedservice_bootstrap.init(CONFIG.EMBEDDED_SERVICE_ID, CONFIG.EMBEDDED_SERVICE_NAME, CONFIG.EMBEDDED_SERVICE_URL, {
        scrt2URL: CONFIG.EMBEDDED_SERVICE_scrt2URL
      });
    } catch (err) {
      logger.error('Error initializing embedded messaging:', err);
    }
  }
  attachEventListeners() {
    window.addEventListener('onEmbeddedMessagingReady', this.handleEmbeddedMessagingReady);
    window.addEventListener('onEmbeddedMessagingButtonCreated', this.handleEmbeddedMessagingButtonCreated);
  }
  observeChatOverlay() {
    const overlay = document.getElementById('embeddedMessagingModalOverlay');
    if (overlay) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (!overlay.classList.contains('isMaximized')) {
              this.toggleChatPanel();
            }
          }
        });
      });
      observer.observe(overlay, {
        attributes: true
      });
    } else {
      logger.error('Element with ID "embeddedMessagingModalOverlay" not found.');
    }
  }
  restoreChatState() {
    const isChatOpen = localStorage.getItem('isAgentforceChatOpen') === 'true';
    if (isChatOpen) {
      this.toggleChatPanel();
    } else {
      this.showChatButton();
    }
  }
  showChatButton() {
    const chatButton = document.getElementById('agentforceChatButton');
    if (chatButton) {
      chatButton.classList.remove('hidden-af');
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AgentforceChat, {
  fields: ["handleEmbeddedMessagingReady", "handleEmbeddedMessagingButtonCreated", "toggleChatPanel"]
});
const __lwc_component_class_internal = _registerComponent(AgentforceChat, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;